module.exports = __webpack_public_path__ + "img/parker-trumbull-hero.20907d3a.webp";